export default __webpack_public_path__ + "static/media/placeholder2.f0fa2c4d.png";